import { DependencyList, EffectCallback, useEffect, useRef } from 'react'

export const useDidMountEffect = (effect: EffectCallback) =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, [])

export const useDidUpdateEffect = (
  effect: EffectCallback,
  deps?: DependencyList
) => {
  const isDidUpdate = useRef(false)

  useEffect(() => {
    if (!isDidUpdate.current) {
      isDidUpdate.current = true

      return
    }

    return effect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
